module.exports = "<div class=\"container\">\n    <div class=\"col-sm-12\">\n        <legend>{{'admin.administration' | translate}}</legend>\n        <hr>\n\n        <app-sensor-parameters></app-sensor-parameters>\n\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/mjahoo/workspace/rento/git/saunasampo-monitor/src/app/admin/admin.component.html
// module id = ../../../../../src/app/admin/admin.component.html
// module chunks = main